










































import Vue from 'vue'
import {Dictionary} from 'vuex'
import {DateTime} from 'luxon'

export default Vue.extend({
  name: 'UiCalendarSheet',
  props: {
    available: Object as () => Dictionary<any>,
    date: {type: DateTime},
    value: {default: ''}
  },
  data () {
    return {
      current: '',
      weekdays: [
        this.$t('labels.weekdays_short.monday'),
        this.$t('labels.weekdays_short.tuesday'),
        this.$t('labels.weekdays_short.wednesday'),
        this.$t('labels.weekdays_short.thursday'),
        this.$t('labels.weekdays_short.friday'),
        this.$t('labels.weekdays_short.saturday'),
        this.$t('labels.weekdays_short.sunday')
      ]
    }
  },
  computed: {
    monthGrid () {
      interface GridDay {
        day: number,
        month: number,
        available: boolean[],
        void?: true
      }

      const date = this.date.reconfigure({}).startOf('month')
      const diff = date.get('weekday') - 1

      type MonthGrid = GridDay | null
      const grid: MonthGrid[] = []
      for (let i = 1; i <= diff; i++) {
        const tmp = date.reconfigure({})
        grid.push({
          day: tmp.plus({days: -(diff - (i - 1))}).toObject().day as number,
          month: tmp.toObject().month as number - 1,
          available: [],
          void: true
        })
      }
      for (let day = 1; day <= date.daysInMonth; day++) {
        const tmp = date.reconfigure({})
        const curDay = date.year + '.' + date.month + '.' + day
        grid.push({
          day,
          month: tmp.toObject().month as number,
          available: this.available[curDay] || []
        })
      }
      const dateEnd = this.date.reconfigure({}).endOf('month')
      const diffEnd = 7 - dateEnd.get('weekday')
      for (let i = 1; i <= diffEnd; i++) {
        const tmp = dateEnd.reconfigure({})
        grid.push({
          day: tmp.plus({days: i}).toObject().day as number,
          month: tmp.toObject().month as number + 1,
          available: [],
          void: true
        })
      }

      return grid
    }
  },
  methods: {
    isDisabled (day: any) {
      if (day.available) {
        for (const available of day.available) {
          if (available) {
            return false
          }
        }
      }
      return true
    },
    hasImportandEvent (day: any) {
      if (day.available) {
        for (const available of day.available) {
          if (available.is_important) {
            return true
          }
        }
      }
      return false
    },
    isToday (day: any) {
      const date = this.date.reconfigure({}).set({day: day.day})
      return DateTime.local().hasSame(date, 'day')
    },
    isSelected (day: any) {
      if (this.value && day) {
        const date = this.date.reconfigure({}).set({day: day.day, month: day.month})
        const curValue = DateTime.fromISO(this.value)
        return curValue.equals(date)
      }
      return false
    },
    onSelect (day: any) {
      if (!day.disabled) {
        const date = this.date.reconfigure({}).set({day: day.day}).toISO()
        this.$emit('input', date)
      }
    }
  }
})
